export default "__VITE_ASSET__NMVLWf4DMBUp84Fp5hzlPw__";